module.exports = __webpack_public_path__ + "media/images/linkedin-ada11cda991129bc91b79d2c7cee1066.svg";